module.exports = __webpack_public_path__ + "img/express.e6b8c04d.jpg";